export default {
  id: null,
  title: "",
  level: { name: "" },
  benchmark: {
    target: 100,
    achieved: 0,
  },
};
